import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getCompanyDetailList = createAsyncThunk(
  "companyDetailList/getCompanyDetailList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/setting/company`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const companyDetailSlice = createSlice({
  name: "companyDetailList",
  initialState: {
    loading: false,
    companyDetailData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCompanyDetailList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCompanyDetailList.fulfilled, (state, action) => {
        state.loading = false;
        state.companyDetailData = action.payload;
      })
      .addCase(getCompanyDetailList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default companyDetailSlice.reducer;
